export { DomainScopedNavHeader } from './domain-scoped-nav-header';
